import httpNodeClient from '@shared/api/httpNodeClient';
import { MetroAreaData } from '@shared/interfaces/MetroAreaData';

export const getMetroAreas = (): Promise<MetroAreaData> =>
  httpNodeClient.get<MetroAreaData>('/metro-areas').then((resp) => resp.data);
